import * as React from 'react';
import { Typography } from '@mui/material';

interface Props {
  children: React.ReactNode;
  tone?: 'muted' | 'error';
  id?: string;
}

function HelperText({ children, tone = 'muted', id }: Props) {
  return (
    <Typography
      id={id}
      variant={tone === 'error' ? 'subtitle2' : 'body2'}
      sx={theme => ({
        color: tone === 'error' ? theme.palette.warning.dark : 'text.secondary',
      })}>
      {children}
    </Typography>
  );
}

export default HelperText;
